import React, { FC } from 'react';
import Form from 'react-bootstrap/Form';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import InputMask from 'react-input-mask';
import { IMaskInput } from 'react-imask';
import Input from '@mui/material/Input';

interface IInputSelect {
    controlId: string;
    label: string;
    placeholder: string;
    handleChange: any;
    handleBlur: any;
    errorsField: any;
    touched: any
    value: any
    mask:any
}

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const TextMaskCustom = React.forwardRef<HTMLElement, CustomProps>(
  function TextMaskCustom(props, ref) {
      
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="000-000-0000"
        definitions={{
          '#': /[1-9]/,
        }}
        unmask={true}
        inputRef={ref}
        onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  },
);


/**
 * Input Type Text Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; }} {
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched, mask
}
 * @returns {*}
 */
const InputPhoneMask: FC<IInputSelect> = ({
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched, value, mask
}) => {
    return (
<>
    {/*{ errorsField && touched ? "error" : ""}*/}
         
        {/*<FormControl fullWidth error={ errorsField && touched} variant="outlined">*/}
            {/*<InputLabel id="demo-simple-select-label">{label}</InputLabel>*/}
            <TextField 
                // mask={mask} 
                type="text" 
                name={controlId}                
                onChange={handleChange} 
                // maskChar={null} 
                placeholder={placeholder} 
                onBlur={handleBlur}  
                error={errorsField && touched }
                label={label} 
                variant="outlined"
                value={value}
                id="formatted-text-mask-input"
                helperText={errorsField && touched?errorsField:""}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                InputProps={{
                  inputComponent: TextMaskCustom as any,
                }}
                // inputComponent={TextMaskCustom  as any}
                // inputComponent={<InputMask mask="999-999-9999" maskChar=" " />}
                // InputProps={{
                //     <InputMask mask="999-999-9999" maskChar=" " />,
                // }}
            /> 
            {/*<InputMask mask="999-999-9999" maskChar=" " />
            </TextField>*/}
            {/*{<FormHelperText>{errorsField && touched?errorsField:""}</FormHelperText>}*/}
        {/*</FormControl> */}

        </>

       
    );
}

export default InputPhoneMask